import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchUPDProductsGrid} from 'api/documents';
import {createListModel} from 'core/hooks/list';
import {rootDomain} from 'core/rootDomain';
import {ProductsUPDItem} from 'types/documents';

const domain = rootDomain.createDomain('DocumentsProductListDomain');

export const Gate = createGate<{reportId: string}>('DocumentsProductListGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchUPDProductsGrid,
});
export const fetchTotalCountFx = domain.createEffect({
    name: 'fetchTotalCountFx',
    handler: fetchUPDProductsGrid,
});

export const {
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    sorting$,
    sortingChanged,
} = createListModel({
    domain,
});

export const data$ = domain.createStore<ProductsUPDItem[]>([]);
export const totalCount$ = domain.createStore<number>(0);

export const listState$ = combine({
    data: data$,
    totalCount: totalCount$,
    filters: filters$,
    sorting: sorting$,
    pageIncremented,
    isLoading: fetchDataFx.pending || fetchTotalCountFx.pending,
});
